module.exports = __webpack_public_path__ + "prize-7.af01c8a4.png";